<template>
    <div>
        <div class="flex flex-col gap-2 w-full h-[73px] py-4 px-9  justify-center items-center  flex-shrink-0" style="background: #1C1C1C;">
            <Logo />
        </div>
        <div class="relative overflow-x-auto px-6 py-4">
            <table class="w-full">
                <thead>
                    <tr>
                        <th v-for="col in columns"
                            class="border-b border-gray-200 px-6 py-4 text-left text-sm font-medium text-black text-opacity-80 tracking-wider">
                            {{ col.text }}
                            <p class="text-sm text-black text-opacity-80 font-bold price whitespace-pre">{{ col.value }}</p>
                        </th>
                    </tr>
                </thead>
                <tbody id="table-body">
                    <tr
                        v-for="item in data"
                        class="border-b border-gray-200 text-black text-opacity-80 text-sm"
                    >
                        <td class="px-6 py-4">{{ item.spread }}</td>
                        <td class="px-6 py-4">{{ item.b3CoinbaseUsdt }}</td>
                        <td class="px-6 py-4">{{ item.coinbaseUsdt }}</td>
                        <td class="px-6 py-4">{{ item.b3KrakenUsdt }}</td>
                        <td class="px-6 py-4">{{ item.krakenUsdt }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-show="loader" class="fixed top-0 left-0 w-full h-screen bg-black bg-opacity-25 flex justify-center items-center">
            <i class="fas fa-spinner animate-spin text-2xl"></i>
        </div>
    </div>
</template>

<script>
import Logo from './Logo.vue'

export default {
    data(){
        return {
            columns: [
                { text: 'Spread', value: '' },
                { text: 'B3 - Coinbase', value: '' },
                { text: '1Forge - Coinbase', value: '' },
                { text: 'B3 - Kraken', value: '' },
                { text: '1Forge - Kraken', value: '' },
            ],
            data: [],
            loader: false,
        }
    },
    methods: {
        async getData() {
            this.loader = true;
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const userSpread = parseFloat(urlParams.get("spread")) || 1;

            try {
                const { data } = await axios.get('/crypto/price')
                const { b3UsdPrice, oneForgeUsdPrice, coinbaseUsdt, krakenUsdt } = this.initializeData(data)
                this.fillCoinbaseData(b3UsdPrice, oneForgeUsdPrice, userSpread, coinbaseUsdt)
                this.fillKrakenData(b3UsdPrice, oneForgeUsdPrice, userSpread, krakenUsdt);
                this.fillTableRows(b3UsdPrice, oneForgeUsdPrice, coinbaseUsdt, krakenUsdt);
            } catch (error) {
                console.log(error);
            } finally {
                this.loader = false;
            }
        },
        fillTableRows(b3UsdPrice, oneForgeUsdPrice, coinbaseUsdt_, krakenUsdt_){
            const spreads = [1.02, 1.015, 1.01, 1.0095, 1.009, 1.0085, 1.008, 1.0075, 1.007, 1.0068, 1.0065, 1.006, 1.0055, 1.005, 1.0038];
            this.data = spreads.map((spread) => {
                const coinbaseUSDT = coinbaseUsdt_?.buy || 0;
                const krakenUSDT = krakenUsdt_?.buy || 0;

                const coinbaseUsdt = oneForgeUsdPrice * spread * coinbaseUSDT;
                const b3CoinbaseUsdt = b3UsdPrice * spread * coinbaseUSDT;

                const krakenUsdt = oneForgeUsdPrice * spread * krakenUSDT;
                const b3KrakenUsdt = b3UsdPrice * spread * krakenUSDT;

                return {
                    spread,
                    b3CoinbaseUsdt: b3CoinbaseUsdt ? this.formatValue(b3CoinbaseUsdt) : 'N/A',
                    coinbaseUsdt: coinbaseUsdt ? this.formatValue(coinbaseUsdt) : 'N/A',
                    b3KrakenUsdt: b3KrakenUsdt ? this.formatValue(b3KrakenUsdt) : 'N/A',
                    krakenUsdt: krakenUsdt ? this.formatValue(krakenUsdt) : 'N/A'
                }
            })
        },
        fillCoinbaseData(b3UsdPrice, oneForgeUsdPrice, userSpread, coinbaseUsdt) {
            if (coinbaseUsdt?.buy) {
                const b3Coinbase = b3UsdPrice * userSpread * coinbaseUsdt.buy;
                const ofCoinbase = oneForgeUsdPrice * userSpread * coinbaseUsdt.buy;

                const [, colB3, colOf] = this.columns
                colB3.value = `(${b3UsdPrice} * ${userSpread} * ${coinbaseUsdt.buy})\n${this.formatValue(b3Coinbase)}`
                colOf.value = `(${oneForgeUsdPrice} * ${userSpread} * ${coinbaseUsdt.buy})\n${this.formatValue(ofCoinbase)}`
            }
        },
        fillKrakenData(b3UsdPrice, oneForgeUsdPrice, userSpread, krakenUsdt) {
            if (krakenUsdt?.buy) {
                const b3Kraken = b3UsdPrice * userSpread * krakenUsdt.buy;
                const ofKraken = oneForgeUsdPrice * userSpread * krakenUsdt.buy;

                const [, , , colB3, colOf] = this.columns;
                colB3.value = `(${b3UsdPrice} * ${userSpread} * ${krakenUsdt.buy})\n${this.formatValue(b3Kraken)}`
                colOf.value = `(${oneForgeUsdPrice} * ${userSpread} * ${krakenUsdt.buy})\n${this.formatValue(ofKraken)}`
            }
        },
        initializeData(data) {
            let b3UsdPrice = data.find(item => item.source === "B3")?.buy || 0;
            let oneForgeUsdPrice = data.find(item => item.source === "1forge")?.buy || 0;

            data = data.filter(item => item.source !== "B3" && item.source !== "1forge");

            const coinbaseUsdt = data.find(coin => coin.source === "coinbase" && coin.name === "USDT");
            const krakenUsdt = data.find(coin => coin.source === "kraken" && coin.name === "USDT");

            return { b3UsdPrice, oneForgeUsdPrice, coinbaseUsdt, krakenUsdt };
        },
        formatValue(value) {
            return `R$ ${value.toFixed(4)}`;
        },
    },
    async created(){
        await this.getData()
        setInterval(this.getData, 5000);
    },
    components: {
        Logo
    }
}
</script>
